import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import {
  Table, Button, Tooltip, Modal, message, Icon,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import wrapReact from '../../../util/react';
import { msgCB } from '../../../util/fetch/msgFetch';
import { actUI } from '../../../redux/action/ui';
import { PAGE_SIZE } from '../../../config';
import { CB_STATUS } from '../../../util/fetch/cFetch';

const delIcon = require('../../../static/image/delete-normal.png');
const downLoadIcon = require('../../../static/image/download-normal.png');
const warningIcon = require('../../../static/image/warningIcon.png');

export class NewTable extends Component {
  handleChange = (page) => {
    const { onChange, dispatch } = this.props;
    const offset = (page.current - 1) * PAGE_SIZE;
    actUI(dispatch, { uiDevice: { offset } });
    onChange({ limit: PAGE_SIZE, offset });
  }

  handleOK = (text) => {
    const { intl, onDelete, dispatch } = this.props;
    const { formatMessage } = intl;
    actUI(dispatch, { uiDevice: { uiTable: { loading: true } } });
    const cb = (res) => {
      actUI(dispatch, { uiDevice: { uiTable: { loading: false } } });
      switch (res.status) {
        case CB_STATUS.FORBID:
          message.config({
            top: 100,
            icon: <Icon type="close-circle" theme="filled" />,
          });
          message.error(
            formatMessage({
              id: 'Device.forbitDel',
              defaultMessage: 'not allow to delete',
            }),
          );
          return;
        default:
          msgCB(res.status, formatMessage);
      }
    };
    onDelete(
      {
        SerialNumber: text.SerialNumber,
      },
      cb,
    );
  }

  translateData = () => {
    const { data } = this.props;
    const newData = JSON.parse(JSON.stringify(data.results));

    return newData;
  }

  render() {
    const {
      intl,
      className,
      filePath,
      ui,
      offset,
      data,
      onEdit,
      onDownloadAccount,
    } = this.props;
    const { formatMessage } = intl;
    const columns = [
      {
        title: (
          <FormattedMessage
            id="Device.serialNumber"
            defaultMessage="serail number"
          />
        ),
        dataIndex: 'SerialNumber',
        key: 'SerialNumber',
        width: 400,
        render: (text, record) => (
          <Button onClick={() => onEdit(record.id)} className="a-click">
            {text}
          </Button>
        ),
      },
      {
        title: (
          <FormattedMessage
            id="Device.displayName"
            defaultMessage="display name"
          />
        ),
        dataIndex: 'DisplayName',
        key: 'DisplayName',
        width: 400,
      },
      {
        title: (
          <FormattedMessage id="app.table.action" defaultMessage="action" />
        ),
        key: 'action',
        render: (text, record, index) => (
          <span>
            <Tooltip
              placement="topLeft"
              title={formatMessage({
                id: 'app.btn.downloadAccount',
                defaultMessage: 'download accounts',
              })}
            >
              <Button
                htmlType="button"
                // type="primary"
                // size="small"
                className="action-button action-download"
                onClick={() => onDownloadAccount({ SerialNumber: text.SerialNumber })
                }
              >
                <img src={downLoadIcon} alt="" style={{ height: '32px', width: '32px' }} />
              </Button>
            </Tooltip>
            <Tooltip
              placement="topLeft"
              title={formatMessage({
                id: 'app.btn.delete',
                defaultMessage: 'delete',
              })}
            >
              <Button
                // type="primary"
                // size="small"
                className="action-button"
                onClick={Modal.confirm.bind(this, {
                  title: formatMessage({
                    id: 'app.warn.confirmDelete',
                    defaultMessage: 'are you sure to delete the release?',
                  }),
                  content: formatMessage({
                    id: 'app.warn.operationIrrevocable',
                    defaultMessage: 'this operation is irrevocable',
                  }),
                  okText: formatMessage({
                    id: 'app.btn.ok',
                    defaultMessage: 'ok',
                  }),
                  cancelText: formatMessage({
                    id: 'app.btn.cancel',
                    defaultMessage: 'cancel',
                  }),
                  onOk: this.handleOK.bind(this, text, record, index),
                  icon: <img src={warningIcon} alt="" />,
                })}
              >
                <img src={delIcon} alt="" style={{ height: '32px', width: '32px' }} />
              </Button>
            </Tooltip>
          </span>
        ),
      },
    ];
    return (
      <Table
        className={`${filePath} ${className}`}
        columns={columns}
        rowKey="id"
        dataSource={this.translateData()}
        locale={{
          emptyText: (
            <FormattedMessage id="app.data.empty" defaultMessage="no data" />
          ),
        }}
        pagination={{
          current: offset / PAGE_SIZE + 1,
          pageSize: PAGE_SIZE,
          total: data.count,
        }}
        loading={ui.loading}
        onChange={this.handleChange}
      />
    );
  }
}

NewTable.propTypes = {
  data: PropTypes.shape({
    count: PropTypes.number.isRequired,
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        SerialNumber: PropTypes.string.isRequired,
        DisplayName: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,
  }).isRequired,
  ui: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  offset: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDownloadAccount: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default wrapReact(NewTable, 'container_device_Table');
